export const RECAPTCHA_ACTION = 'wf_verify_recaptcha'

export const CLOUDFLARE_TURNSTILE_ACTION = 'wf_verify_cloudflare_turnstile'

export type ChallengePayload = {
  recaptcha_token?: string | undefined
  recaptcha_action?: string
  cloudflare_turnstile_token?: string | undefined
}

type ChallengeExecutor = (action: string) => Promise<string | undefined>

type ExecuteChallengeParams = {
  recaptchaEnabled: boolean
  cloudflareTurnstileEnabled: boolean
  executeRecaptcha: ChallengeExecutor
  executeCloudflareTurnstile: ChallengeExecutor
}

const executeChallenge = ({
  recaptchaEnabled,
  cloudflareTurnstileEnabled,
  executeRecaptcha,
  executeCloudflareTurnstile
}: ExecuteChallengeParams): Promise<ChallengePayload> => {
  if (recaptchaEnabled) {
    return executeRecaptcha(RECAPTCHA_ACTION).then(token => ({
      recaptcha_token: token,
      recaptcha_action: RECAPTCHA_ACTION
    }))
  }

  if (cloudflareTurnstileEnabled) {
    return executeCloudflareTurnstile(CLOUDFLARE_TURNSTILE_ACTION).then(token => ({
      cloudflare_turnstile_token: token
    }))
  }

  return Promise.resolve({})
}

export default executeChallenge
